import { createFileRoute } from '@tanstack/react-router';

import { getAwardOptions } from '@/module/Author/Award';

export const Route = createFileRoute('/_auth/author/_author/award/_award/$awardId/_layout')({
  loader: async ({ params: { awardId }, context: { queryClient } }) => {
    const award = await queryClient.ensureQueryData(getAwardOptions(awardId));

    return {
      award,
      crumb: award.title,
    };
  },
});
